import { render, staticRenderFns } from "./orgAccResult.vue?vue&type=template&id=09f19f20&"
import script from "./orgAccResult.vue?vue&type=script&lang=js&"
export * from "./orgAccResult.vue?vue&type=script&lang=js&"
import style0 from "./orgAccResult.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports